import { LINKS } from "./links";

export interface NavItem {
	label: string;
	href: string;
}

export const NAV_ITEMS: NavItem[] = [
	{ label: "О нас", href: LINKS.about },
	{ label: "Услуги", href: LINKS.services },
	{ label: "Контакты", href: LINKS.contacts },
];
